import React, { useState } from "react"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function Stars(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { readOnly = false, currentVote, setCurrentVote = () => {} } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleStarClick(index) {
    return (e) => {
      if (!readOnly) {
        setCurrentVote(index + 1)
      }
      e.preventDefault()
    }
  }

  function renderStars(starsFloat) {
    let stars = Math.round(starsFloat)
    let filled = Array(stars).fill(true)
    let empty = Array(5 - stars).fill(false)

    return filled.concat(empty).map((el, index) => {
      return (
        <i
          key={`stars-${index}`}
          className={`fa${el ? "s" : "l"} fa-star ${style.star}`}
          onClick={handleStarClick(index)}
        ></i>
      )
    })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={`${style.container} ${props.className}`}>
      {renderStars(currentVote || 0)}
    </div>
  )
}

// ----------------------------------------------------------------------------

export default Stars
